import React from 'react';
import {
  withRouter,
} from 'react-router-dom';
import {
  Link,
  Grid,
  Typography,
} from '@material-ui/core';

import translations from '../../languages/i18n';
import { noMatch } from '../../styles/formElementsStyles';

function WrongBrowser() {
  const noMatchStyle = noMatch();
  return (
    <div className={noMatchStyle.content}>
      <Grid container direction='row' spacing={2} alignItems='center' justify='center'>
        <Grid item>
          <img src={require('../../assets/images/logoHT.png')} alt='HT Logo' width='150' heigth='150' />
        </Grid>
        <Grid item>
          <Typography component='h1' variant='h4'>{translations['_wrongBrowser']}</Typography>
          <Typography component='h1' variant='h5'>{translations['_recomendedBrowsers']}</Typography>
          <Link href='https://www.google.com/intl/es_ES/chrome/' variant='body1'>Google Chrome</Link>
          <Typography component='body1' variant='body1'>, </Typography>
          <Link href='https://www.mozilla.org/es/firefox/new/' variant='body1'>Mozilla Firefox</Link>
          <Typography component='body1' variant='body1'>, </Typography>
          <Link href='https://www.microsoft.com/es-es/edge' variant='body1'>Microsoft Edge</Link>
        </Grid>
      </Grid>
    </div>
  );
}

export default withRouter(WrongBrowser);
